module.exports = __webpack_public_path__ + "static/img/cybercrime_4.6f647ca6.png";